'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

var _traits = require('./traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_EMAIL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CREATED_AT, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number])), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track registration events
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackRegister() {
    var _extends2;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_REGISTRATION + ' event');
    return (0, _track2.default)(_events.EVENT_REGISTRATION, (0, _extends4.default)((_extends2 = {}, (0, _defineProperty3.default)(_extends2, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_CREATED_AT, traits[_traits.TRAIT_CREATED_AT] || Date.now()), _extends2), traits));
}

exports.default = trackRegister;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackRegister.js
// module id = 1788
// module chunks = 0